import { gql } from '@apollo/client';
export const CHAT_WITH_DOCUMENT_REVIEW_MUTATION = gql `
  mutation ChatWithDocumentReview($messages: [ReviewChatMessageInput!]!, $feedbackId: ID!) {
    chatWithDocumentReview(messages: $messages, feedbackId: $feedbackId) {
      token
    }
  }
`;
